/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetVideosOptions, AdminGetVideosResponses } from '../../models/AdminGetVideos'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary List Videos
 * {@link /admin/videos}
 */
export function adminGetVideos<ThrowOnError extends boolean = true>(options: Options<AdminGetVideosOptions, ThrowOnError> = {}): Promise<UnwrappedResult<AdminGetVideosResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/videos', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetVideosResponses, ThrowOnError>>
}
